import React from 'react';
import { Outlet } from 'react-router-dom';

export default function UniverseLayout() {
  return (
    <div className="universe-layout-wrapper">
      <Outlet />
    </div>
  );
}
